import React from 'react';
import { FaProjectDiagram, FaUsers, FaAward } from 'react-icons/fa';
import './About.css';
import aboutImage from '../../assets/Logo MulByte version 1 ameliorer.png';

const About = () => {
  const stats = [
    { number: "10+", label: "Projets réalisés", icon: <FaProjectDiagram size={30} /> },
    { number: "100%", label: "Clients satisfaits", icon: <FaUsers size={30} /> },
    { number: "10", label: "Prix d'excellence", icon: <FaAward size={30} /> }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">À Propos de Nous</h2>
            <p className="lead">
              Mulbyte est une agence digitale créative spécialisée dans le développement web,
              mobile et les stratégies digitales. Fondée en 2023, notre équipe d'experts s'engage
              à fournir des solutions innovantes qui propulsent votre entreprise vers le succès.
            </p>
            <p>
              Nous accompagnons les entreprises, ONG, entrepreneurs, associations et médias dans leur transition digitale grâce à des services sur-mesure qui répondent à leurs besoins en visibilité, performance et croissance.
            </p>
            <p>
              Notre approche combine créativité, technologie et stratégie pour offrir des résultats
              concrets à nos clients. Nous croyons en des partenariats à long terme et nous nous
              engageons à comprendre vos besoins spécifiques pour fournir des solutions sur mesure.
            </p>

            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-icon">{stat.icon}</div>
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="about-image">
            <img src={aboutImage} alt="Notre équipe" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;